import { getLocale, trDisplay, trTemplate } from '../../i18n';
import { SWR_WITHDRAWAL_STRATEGIES } from '../../lib/simulation/swrWithdrawalStrategies';

const strategyNames = {
  personalized: 'Personalizzata',
  vanguard: 'Vanguard',
  'guyton-klinger': 'Guyton–Klinger',
  'constant-real': 'Reale costante',
  'skip-inflation': 'Salta inflazione',
};

// Keep useful precision even when an amount is expressed in thousands/millions.
const compactAmount = value => {
  if (typeof value !== 'number' || !Number.isFinite(value)) return '—';
  const unit = value >= 1e6 ? 1e6 : value >= 1e3 ? 1e3 : 1;
  const suffix = unit === 1e6 ? 'M' : unit === 1e3 ? 'k' : '';
  return `${new Intl.NumberFormat(getLocale(), { maximumFractionDigits: 8 }).format(value / unit)}${suffix}€`;
};

export function buildSWRScenarioName(params = {}) {
  const id = typeof params.withdrawalStrategy === 'string' ? params.withdrawalStrategy : params.withdrawalStrategy?.id;
  const strategy = trDisplay(strategyNames[id || 'personalized'] || SWR_WITHDRAWAL_STRATEGIES.find(item => item.id === id)?.label || 'Strategia');
  const firstPeriod = (params.withdrawalPeriodsToday || params.withdrawalPeriods || [])[0];
  const annual = params.realWithdrawalYear0Today ?? params.realWithdrawalYear0
    ?? firstPeriod?.annualWithdrawal ?? (firstPeriod?.monthlyWithdrawal == null ? null : firstPeriod.monthlyWithdrawal * 12);
  const monthly = annual == null ? null : annual / 12;
  return `${strategy} · ${compactAmount(params.initialCapital)} · ${compactAmount(monthly)}/m · ${trTemplate('{{years}}a', { years: params.yearsToSimulate ?? '—' })}`;
}
